import { useState } from 'react';
import { classNames } from '~/utils/classNames';

interface CopyToClipboardButtonProps {
  code: string;
  disabled?: boolean;
  className?: string;
}

export const CopyToClipboardButton = ({ code, disabled = false, className }: CopyToClipboardButtonProps) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    if (copied) {
      return;
    }

    navigator.clipboard.writeText(code);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <div
      className={classNames(
        'bg-alpha-background-editor-secondary absolute top-[10px] right-[10px] rounded-md z-10 text-lg flex items-center justify-center opacity-0 group-hover:opacity-100',
        {
          'rounded-l-0 opacity-100': copied,
        },
        className,
      )}
    >
      {!disabled && (
        <button
          className={classNames('flex items-center bg-transparent p-[6px] justify-center')}
          title="Copy Code"
          onClick={() => copyToClipboard()}
        >
          {copied ? <div className="i-ph:check"></div> : <div className="i-ph:clipboard-text-duotone"></div>}
        </button>
      )}
    </div>
  );
};
